export const getMessageForRequiredFields = (inputName: string) => `${inputName} is required`;

export const getMessageForInvalidFields = (inputName: string) => `Invalid ${inputName}`;

export const getMessageForMinLength = (inputName: string, minLength: number) =>
  `${inputName} must be at least ${minLength} characters`;
